/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Tab_PrepareInputs */

const en_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare`)
};

const de_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereitung`)
};

const fr_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation`)
};

const es_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación`)
};

const it_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione`)
};

const nl_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbereiden`)
};

const pl_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie`)
};

const fi_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmistelu`)
};

const da_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forberedelse`)
};

const sv_interview_tab_prepare = /** @type {(inputs: Interview_Tab_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förberedelse`)
};

/**
* | output |
* | --- |
* | "Prepare" |
*
* @param {Interview_Tab_PrepareInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_tab_prepare = /** @type {((inputs?: Interview_Tab_PrepareInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Tab_PrepareInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_tab_prepare(inputs)
	if (locale === "fr") return fr_interview_tab_prepare(inputs)
	if (locale === "es") return es_interview_tab_prepare(inputs)
	if (locale === "it") return it_interview_tab_prepare(inputs)
	if (locale === "nl") return nl_interview_tab_prepare(inputs)
	if (locale === "pl") return pl_interview_tab_prepare(inputs)
	if (locale === "fi") return fi_interview_tab_prepare(inputs)
	if (locale === "da") return da_interview_tab_prepare(inputs)
	if (locale === "sv") return sv_interview_tab_prepare(inputs)
	return en_interview_tab_prepare(inputs)
});